import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientDashboardComponent } from './client-dashboard.component';
import { SharedModule } from 'src/app/modules/shared.module';
import { ClientDashboardRoutingModule } from './client-dashboard-routing.module';
import { ZoneModule } from '../zone/zone.module';
import { OverviewComponent } from './overview/overview.component';
import { CyclesComponent } from './cycels/cycles.component';
import { SensorsComponent } from './sensors/sensors.component';
import { AppliancesComponent } from './appliances/appliances.component';
import { GatewaysComponent } from './gateways/gateways.component';



@NgModule({
  declarations: [ClientDashboardComponent, OverviewComponent, CyclesComponent,
    SensorsComponent, AppliancesComponent, GatewaysComponent],
  imports: [
    CommonModule,
    SharedModule,
    ClientDashboardRoutingModule,
    ZoneModule,
  ]
})
export class ClientDashboardModule { }
